import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayout from "../layouts/footer.layout";
import banner from "../styles/images/banner_superior_productos.webp";
import DetalleComponent from "../components/producto/detalle.component";
import { productos } from "../libs/productosV3";
import { useParams } from "react-router-dom";
import RelacionadosComponent from "../components/producto/relacionados.component";
/*eslint-disable */
const ProductoPage: React.FC = () => {
  const { category, product } = useParams();
  const [categoriesSelected, setCategoriesSelected]: any = useState({})
  const [productsSelected, setProductsSelected]: any = useState({})
  const [productosFiltrados, setProductosFiltrados] = useState<any[]>([]);
  useEffect(() => {
    //setCategoriesSelected(productos.find((categories: any) => categories.slug === category))
    const productoEncontrado = productos.find((producto: any) => producto.slug === product)
    setProductsSelected(productoEncontrado)
    if (productoEncontrado) {
      // Paso 2: Obtener las categorías del producto encontrado
      const categoriasDelProducto = productoEncontrado.categorias;

      // Paso 3: Filtrar los productos que pertenecen a las mismas categorías
      const productosEnLasMismasCategorias = productos.filter((producto: any) =>
        producto.categorias.some((categoria: string) => categoriasDelProducto.includes(categoria))
      );

      // Paso 4: Limitar a los primeros 10 productos encontrados
      const productosLimitados = productosEnLasMismasCategorias.slice(0, 10);

      setProductosFiltrados(productosLimitados); // Guardar los productos filtrados en el estado
    }
  }, [])
  
  
  return (
    <>
      <MenuLayouts />
      <div className="page-title-area" style={{backgroundImage: `URL(${banner})`, backgroundSize: "cover", backgroundPosition: "center"}}>
        <div className="container">
          <div className="page-title-content">
            <h1 style={{color: "#fff"}}>{productsSelected?.category}</h1>
          </div>
        </div>
      </div>
      <DetalleComponent product={productsSelected}/>
      <RelacionadosComponent category={productosFiltrados}/>
      <FooterLayout />
    </>
  );
};

export default ProductoPage;
